import React, { useContext } from "react";
import CookieConsent, { CookieConsentProps } from "react-cookie-consent";
import { MicroCopyContext } from "@unum/micro-copy";
import Heading from "@unum/heading";
import styles from "./CookieBanner.module.scss";

type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
} & CookieConsentProps;

const CookieBanner = ({ title, children, ...rest }: Props) => {
  const getMicroCopy = useContext(MicroCopyContext);
  return (
    <div className={styles["wrapper"]}>
      <CookieConsent
        buttonClasses="button button--primary button--pill"
        declineButtonClasses="button button--tertiary button--pill"
        buttonText={getMicroCopy("cookie-consent.accept")}
        declineButtonText={getMicroCopy("cookie-consent.decline")}
        containerClasses={styles["CookieBanner"]}
        disableStyles={true}
        enableDeclineButton
        expires={150}
        {...rest}
      >
        <Heading component="h2" level={5}>
          {title}
        </Heading>
        {children}
      </CookieConsent>
    </div>
  );
};

export default CookieBanner;
